export default __webpack_public_path__ + "static/media/sad-trombone.2367eb11.mp3";